import { angularServicesNames } from "@topline/services/angularServicesNames";

(function (module) {
    "use strict";

    module.component('smoothData', {
        template: require('./smoothDataComponent.html'),
        bindings: {
            enter: '=',
            labels: '<',
            period: '=',
            inputData: '<',
            parameters: '<',
            forecast: "=",
            isEditable: "<"
        },
        controller: ['$scope', 'ChartsConfig', 'smoothDataService', angularServicesNames.$translate, 'synchronousEventsBus',
            function(
                this: $TSFixMe,
                $scope: $TSFixMe,
                ChartsConfig: $TSFixMe,
                smoothDataService: $TSFixMe,
                $translate: ng.translate.ITranslateService,
                synchronousEventsBus: $TSFixMe
            ) {
                var $ctrl = this;
                $ctrl.datasetOverride = ChartsConfig.datasetOverride;
                $ctrl.options = ChartsConfig.options;

                $scope.$on('LanguageChanged', () => resetChartTranslations());
                resetChartTranslations();

                function resetChartTranslations() {
                    $translate(['CHART_SERIES.DATA_BEFORE_SMOOTHING', 'CHART_SERIES.DATA_AFTER_SMOOTHING']).then(function (translations: $TSFixMe) {
                        $ctrl.beforeSmoothSeries = translations["CHART_SERIES.DATA_BEFORE_SMOOTHING"];
                        $ctrl.afterSmoothSeries = translations["CHART_SERIES.DATA_AFTER_SMOOTHING"];
                        $ctrl.series = [$ctrl.beforeSmoothSeries, $ctrl.afterSmoothSeries];
                    });
                }

                function refreshSmoothing() {

                    if (angular.isUndefinedOrNull($ctrl.forecast) || !$ctrl.isEditable)
                        return;

                    smoothDataService.smoothData($ctrl.forecast, $ctrl.parameters, $ctrl.period);
                }

                synchronousEventsBus.$on('dataAfterSmoothingChanged', function (e: $TSFixMe, args: $TSFixMe) {

                    if (angular.isUndefinedOrNull($ctrl.forecast))
                        return;

                    $ctrl.chartData = [
                        $ctrl.forecast.dataAfterSkipped,
                        $ctrl.forecast.dataAfterSmoothing
                    ];
                });

                $ctrl.$onInit = function () {
                    if ($ctrl.forecast.dataAfterSkipped || $ctrl.forecast.dataAfterSmoothing) {
                        $ctrl.chartData = [
                            $ctrl.forecast.dataAfterSkipped,
                            $ctrl.forecast.dataAfterSmoothing
                        ];
                    }
                }

                $ctrl.periodChanged = () => refreshSmoothing();

                $ctrl.isMlModelAndNotReady = (avg: $TSFixMe) => $ctrl.forecast.regression == 'machine_learning' &&
                    
                    !_.some($ctrl.forecast.machineLearningData, (ml: $TSFixMe) => ml.calculationIsReady && ml.monthNumberForAverage == avg);
                
                $ctrl.isMlModelAndHasMissingModels = () => $ctrl.forecast && $ctrl.forecast.regression == 'machine_learning' &&
                    
                    _.some($ctrl.forecast.machineLearningData, (ml: $TSFixMe) => !ml.calculationIsReady);
            }]
    });

})(angular.module('topline.modules'));